<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('message.' + langItem.langCode)"
                    v-for="(langItem, index) in detailInfo.lstPublicityLangMapDTO" :key="index">
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Title </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.title'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur',
                                    }">
                                        <el-input v-model="langItem.title" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Cover Image </label>
                                <div class="col-sm-10">
                                    <el-upload class="upload-demo upload-image" action="#" multiple
                                        :http-request="(e) => { uploadFile(e, index) }" :auto-upload="true"
                                        accept=".png, .jpg , .jpeg" :show-file-list="false">
                                        <div slot="tip" v-if="uploadErr" style="color:red;font-size:10px;"
                                            class="el-upload__tip">The uploaded
                                            file should not exceed 5MB</div>
                                        <div class="input-group img-group">
                                            <div class="text-center dropzone logo">
                                                <div class="addImage" v-if="!langItem.showCoverImage"
                                                    style="width: 100%; padding-top: 25px; color: #fff">
                                                    <a class="addImageIcon btn btn-primary btn-circle">
                                                        <i class="el-icon-upload2"></i>
                                                    </a>
                                                    <p class="text-primary m-t-sm font14 suggestFont">
                                                        <slot name="sizeHint"></slot>
                                                    </p>
                                                </div>
                                                <div class="editImage" v-if="langItem.showCoverImage">
                                                    <div class="mask-bg"></div>
                                                    <img :src="langItem.showCoverImage" />
                                                    <div class="icon-center">
                                                        <span class="edit-icon">
                                                            <i class="el-icon-edit"></i>
                                                        </span>
                                                        <p class="font14 font-white editFont">Modify</p>
                                                        <p class="text-primary font-white m-t-sm font14 suggestFont">
                                                            <slot name="sizeHint"></slot>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-upload>
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.showCoverImage'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'change',
                                    }">
                                        <el-input style="display: none" v-model="langItem.showCoverImage"
                                            show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Intro
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstPublicityLangMapDTO.' + index + '.intro'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }">
                                        <el-input v-model="langItem.intro" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label"> Status </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="status" :rules="{
                                        required: false,
                                        message: $t('message.required'),
                                        trigger: 'change',
                                    }">
                                        <el-select v-model="detailInfo.status" disabled
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button :disabled="!(
                                            !detailInfo.status ||
                                            detailInfo.status == 3 ||
                                            detailInfo.status == 4
                                        )
                                            " type="primary" @click="checkEvent()">Save</el-button>
                                        <el-button @click="showWarning()">{{
                                            $t("message.Cancel")
                                        }}</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <el-collapse v-model="activeNames" v-show="detailInfo.id">
                        <el-collapse-item title="Sub Section List" name="1">
                            <div class="col-sm-12">
                                <div class="float-e-margins">
                                    <div class="ibox-content">
                                        <div class="row table-responsive" style="padding-bottom: 60px">
                                            <div class="form-group  margin-0">
                                                <label class="col-sm-2 control-label">
                                                    Title
                                                </label>
                                                <div class="col-sm-4">
                                                    <div>
                                                        <el-input v-model="searchName" name="search"></el-input>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class>
                                                        <el-button type="primary" @click="handleCurrentChange(1)">{{
                                                            $t("message.Search")
                                                        }}</el-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="pull-right">
                                                    <el-button @click="gotoSubDetail">{{
                                                        $t("message.Add") }}</el-button>
                                                    <el-button @click="Delete">{{ $t("message.Delete")
                                                    }}</el-button>
                                                </div>
                                            </div>
                                            <div class="col-xs-12">
                                                {{ total }}{{ $t("message.datagridresult") }}
                                            </div>
                                            <el-table :data="subGroupList" border style="width: 100%" ref="multipleTable"
                                                @selection-change="handleSelectionChange" row-key="id"
                                                :cell-class-name="cell" :row-class-name='sortableFilter'>
                                                <el-table-column type="selection" width="55"></el-table-column>
                                                <el-table-column sortable prop="title" :show-overflow-tooltip="true"
                                                    label="Title" min-width="100"></el-table-column>
                                                <el-table-column sortable prop="createdAt" label="Created At" width="220">
                                                </el-table-column>
                                                <el-table-column prop="statusName" label="Status" width="170">
                                                    <template slot-scope="scope">
                                                        {{ statusMap[scope.row.status] }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column width="250">
                                                    <template slot-scope="scope">
                                                        <StatusBtn :id="scope.row.id" :status="scope.row.status"
                                                            :init="getSubList" :type="'PUBLICITY'"
                                                            :approval="'publicity_LIST_APPROVAL'"></StatusBtn>

                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="Action" width="180" fixed="right">
                                                    <template slot-scope="scope">
                                                        <el-row>
                                                            <el-col :span="6" style="float:right" v-if="canDrag">
                                                                <div class="text-center dragTip">=</div>
                                                            </el-col>
                                                            <el-col :span="9" style="float: right">
                                                                <el-button :disabled="![5, 6].includes(scope.row.status)"
                                                                    size="mini" @click="handlePreposition(scope.row)"
                                                                    icon="el-icon-caret-top"></el-button>
                                                            </el-col>
                                                            <el-col :span="9" style="float:right">
                                                                <el-button size="mini" @click="handleDbClick(scope.row)"
                                                                    icon="el-icon-edit"></el-button>
                                                            </el-col>
                                                        </el-row>

                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                            <el-col :span="24" class="el-table_footertoolbar">
                                                <el-pagination layout="total, sizes, prev, pager, next, jumper"
                                                    @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                                    :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :total="total"
                                                    style="float:right;">
                                                </el-pagination>
                                            </el-col>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</template>
<script>
import config from "../config";
import Sortable from "sortablejs";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            detailInfo: {
                lstPublicityLangMapDTO: [],
                id: null,
                status: 0,
                subCategory: '',
                selectDate: null,
                parentId: null
            },

            multipleSelection: [],
            page: 1, //当前页数
            pagesize: 100, //一页显示几条
            total: 0,
            activeNames: ["1"],
            subGroupList: [],
            canDrag: false,
            uploadErr: false,
            searchName: ''
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        statusList() {
            return [
                { label: 'Draft', value: 0 },
                { label: 'Pending approval', value: 1 },
                { label: 'Pending Publish', value: 2 },
                { label: 'Rejected', value: 3 },
                { label: 'Suspended', value: 4 },
                { label: 'Pending Suspend', value: 5 },
                { label: 'Published', value: 6 },
            ]
        },
        statusMap() {
            return {
                0: 'Draft',
                1: 'Pending approval',
                2: 'Pending Publish',
                3: 'Rejected',
                4: 'Suspended',
                5: 'Pending Suspend',
                6: 'Published'
            }
        }
    },
    components: {
        StatusBtn,
    },
    watch: {
        _language: function () {
            this.setObj();
        },
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true,
        },
    },
    created() {
        var obj = [];
        for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
            obj.push({
                langCode: this.$store.state.userInfo.language[i].langCode,
                content: "",
                coverImage: '',
                externalUrl: '',
                intro: '',
                lstPublicityAttachmentDTO: [],
                lstPublicityImagesDTO: [
                    // fileType:1,
                    // fileUrl:'',
                    // fkPublicityLangMapId:'',
                    // showFileUrl:'',
                    // sortOrder:''
                ],
                videoImgList: [],
                showCoverImage: '',
                title: '',
                documentListIsNull: '',
                imageListIsNull: ''
            });
        }
        this.canDrag = true;
        this.$set(this.detailInfo, "lstPublicityLangMapDTO", obj);
        this.init();
        this.getSubList();
    },
    mounted() {
        const table = document.querySelector(".el-table__body-wrapper tbody");
        var self = this;
        Sortable.create(table, {
            onEnd({ newIndex, oldIndex }) {
                self.updateNewsOrder(newIndex, oldIndex);
            },
            filter: ".disabled",
            onMove: (event) => {
                return !event.related.classList.contains("disabled");
            },
        });
    },
    methods: {
        sortableFilter(item) {
            return [2, 5, 6].includes(item.row.status) ? '' : 'disabled'
        },
        handleSizeChange(val) {
            this.pagesize = val
            this.getSubList()
        },
        handleCurrentChange(val) {

            this.page = val
            this.getSubList()
        },
        setObj: function () {

        },
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.publicityDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                delete data.data.result["userId"];
                if (!data.data.result.frontCoverImg) {
                    data.data.result.frontCoverImg = {};
                }
                if (!data.data.result.id) data.data.result.id = this.$route.query.id;
                this.$set(this, "detailInfo", data.data.result);
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
            this.setObj();
        },
        async getSubList() {
            var objdata = this.getAuthObj();

            objdata.pageIndex = this.page;
            objdata.pageSize = this.pagesize;
            objdata.title = this.searchName
            objdata.parentId = this.$route.query.id ? Number(this.$route.query.id) : this.$route.query.id;
            objdata.apiUrl = this.apiConfig.publicityList;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.subGroupList = data.data.result["publicityList"];
            this.setObj();

            this.total = data.data.result.total;
        },
        cell: function ({ row }) {
            if (!this.canDrag) {
                return "disabled pointer";
            }
            return "cursor-move";
        },
        async updateNewsOrder(newIndex, oldIndex) {
            var item = this.subGroupList[oldIndex];
            this.subGroupList.splice(oldIndex, 1);
            this.subGroupList.splice(newIndex, 0, item);
            let sortOrder = [];
            let objdata = this.getAuthObj();
            for (let i = 0; i < this.subGroupList.length; i++) {
                sortOrder.push({
                    id: this.subGroupList[i].id,
                    displayOrder: this.subGroupList[i].sortOrder
                });
            }
            objdata.lstOrderDTO = sortOrder;

            objdata.apiUrl = this.apiConfig.publicityOrder;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.getSubList();
        },
        async handlePreposition(item) {
            var objdata = this.getAuthObj();
            objdata.title = this.searchName;
            objdata.id = item.id;
            objdata.parentId = this.$route.query.id ? Number(this.$route.query.id) : this.$route.query.id

            objdata.apiUrl = this.apiConfig.publicityPreposition;
            let data = await this.$store.dispatch("apiEvent", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            await this.getSubList();
        },
        checkEvent: function () {
            this.$refs["detailInfo"].validate((valid) => {
                if (valid) {
                    this.submit();
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false,
                                });
                                that.deleteList();
                            },
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false,
                                });
                            },
                        },
                    ],
                });
            }
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                for (var key in this.detailInfo) {
                    obj[key] = this.detailInfo[key];
                }
                var data;
                if (this.$route.query.id) {
                    obj.id = this.detailInfo.id;
                    obj.apiUrl = this.apiConfig.publicityUpdate;
                    data = await this.$store.dispatch("apiEvent", obj);
                } else {
                    obj.apiUrl = this.apiConfig.publicityCreate;
                    data = await this.$store.dispatch("apiEvent", obj);
                }
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { }
        },
        Delete() {
            this.showWarning(1);
        },
        async callDelete() { },
        async uploadFile(params, langIndex) {
            if (!this.handleCheckUploadFileSize(params.file)) return false
            let obj = this.getAuthObj();
            obj.file = params.file;
            obj.apiUrl = this.apiConfig.upload;
            var data = await this.$store.dispatch("apiEventFromData", obj);
            if (data == this.TOKEN_EXPIRED) {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.detailInfo.lstPublicityLangMapDTO[langIndex].coverImage = data.data.result.url;
            this.detailInfo.lstPublicityLangMapDTO[langIndex].showCoverImage = data.data.result.showUrl;
        },
        async deleteList() {
            let ids = [];
            let objdata = this.getAuthObj();
            if (this.multipleSelection.length != 0) {
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    ids.push(this.multipleSelection[i].id);
                }
            }
            objdata.ids = ids.join(",");

            objdata.apiUrl = this.apiConfig.publicityDelete;
            let data = await this.$store.dispatch("apiEventFromData", objdata);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            if (data.data.status_code === "0") {
                this.$store.commit("setwarning", {
                    string: "",
                    boolean: false,
                    button: [],
                });
                this.getSubList();
            }
        },
        handleDbClick: function (row) {
            this.$router.push({
                path: "/main/publicitySubDetail",
                query: {
                    id: row.id,
                    parentId: this.detailInfo.id,
                },
            });
        },
        gotoSubDetail() {
            this.$router.push({
                path: "/main/publicitySubDetail",
                query: {
                    parentId: this.detailInfo.id,
                },
            });
        },
        handleCheckUploadFileSize(file) {
            const sizeKB = file.size / 1024
            if (sizeKB > 5120) {
                this.uploadErr = true
                return false
            } else {
                this.uploadErr = false
                return true
            }

        }
    },
};
</script>
  